/**
 * Use this class to ensure Google Maps API javascript is loaded before running any google map specific code.
 */
export class GoogleMapsApi {
	/**
	 * Constructor set up config.
	 */
	constructor() {
		// api key for google maps
		this.apiKey = 'AIzaSyDSPmcEtOunGtB0IS08cVBlrXxp_cATcCc';
		// set a globally scoped callback if it doesn't already exist
		if (!window._GoogleMapsApi) {
			this.callbackName = '_GoogleMapsApi.mapLoaded';
			window._GoogleMapsApi = this;
			window._GoogleMapsApi.mapLoaded = this.mapLoaded.bind(this);
		}
	}

	/**
	 * Default map styles
	 */
	get styles() {
		return [
			{
				'elementType': 'geometry',
				'stylers': [
					{
						'color': '#f5f5f5',
					},
				],
			},
			{
				featureType: 'poi.business',
				stylers: [{visibility: 'off'}],
			},
			{
				featureType: 'transit',
				elementType: 'labels.icon',
				stylers: [{visibility: 'off'}],
			},
			{
				'elementType': 'labels.icon',
				'stylers': [
					{
						'visibility': 'off',
					},
				],
			},
			{
				featureType: 'poi.medical',
				stylers: [{visibility: 'on'}],
			},
			{
				featureType: 'poi.park',
				elementType: 'labels.icon',
				stylers: [{visibility: 'on'}],
			},
			{
				'elementType': 'labels.text.fill',
				'stylers': [
					{
						'color': '#616161',
					},
				],
			},
			{
				'elementType': 'labels.text.stroke',
				'stylers': [
					{
						'color': '#f5f5f5',
					},
				],
			},
			{
				'featureType': 'administrative.land_parcel',
				'elementType': 'labels.text.fill',
				'stylers': [
					{
						'color': '#bdbdbd',
					},
				],
			},
			{
				'featureType': 'poi',
				'elementType': 'geometry',
				'stylers': [
					{
						'color': '#eeeeee',
					},
				],
			},
			{
				'featureType': 'poi',
				'elementType': 'labels.text.fill',
				'stylers': [
					{
						'color': '#757575',
					},
				],
			},
			{
				'featureType': 'poi.park',
				'elementType': 'geometry',
				'stylers': [
					{
						//   "color": "#2f8a56"
						'color': '#ddffdd',
					},
				],
			},
			{
				'featureType': 'poi.park',
				'elementType': 'labels.text.fill',
				'stylers': [
					{
						'color': '#6fac89',
					},
				],
			},
			{
				'featureType': 'poi.medical',
				'elementType': 'geometry',
				'stylers': [
					{
						//   "color": "#ca3433"
						'color': '#b0b0b0',

					},
				],
			},
			{
				'featureType': 'poi.medical',
				'elementType': 'labels.text.fill',
				'stylers': [
					{
						'color': '#9e9e9e',
						// "color": "#ca3433"
					},
				],
			},
			{
				'featureType': 'road',
				'elementType': 'geometry',
				'stylers': [
					{
						'color': '#ffffff',
					},
				],
			},
			{
				'featureType': 'road.arterial',
				'elementType': 'labels.text.fill',
				'stylers': [
					{
						'color': '#757575',
					},
				],
			},
			{
				'featureType': 'road.highway',
				'elementType': 'geometry',
				'stylers': [
					{
						'color': '#dadada',
					},
				],
			},
			{
				'featureType': 'road.highway',
				'elementType': 'labels.text.fill',
				'stylers': [
					{
						'color': '#616161',
					},
				],
			},
			{
				'featureType': 'road.local',
				'elementType': 'labels.text.fill',
				'stylers': [
					{
						'color': '#9e9e9e',
					},
				],
			},
			{
				'featureType': 'transit.line',
				'elementType': 'geometry',
				'stylers': [
					{
						'color': '#e5e5e5',
					},
				],
			},
			{
				'featureType': 'transit.station',
				'elementType': 'geometry',
				'stylers': [
					{
						'color': '#eeeeee',
					},
				],
			},
			{
				'featureType': 'water',
				'elementType': 'geometry',
				'stylers': [
					{
						'color': '#c9c9c9',
					},
				],
			},
			{
				'featureType': 'water',
				'elementType': 'labels.text.fill',
				'stylers': [
					{
						'color': '#9e9e9e',
					},
				],
			},
		];
	}
	/**
	 * Load the Google Maps API javascript
	 */
	load() {
		if (!this.promise) {
			this.promise = new Promise((resolve) => {
				this.resolve = resolve;
				if (typeof window.google === 'undefined') {
					const script = document.createElement('script');
					script.src = `//maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places&callback=${this.callbackName}`;
					script.async = true;
					$(document.body).append(script);
				} else {
					this.resolve();
				}
			});
		}

		return this.promise;
	}

	/**
	 * Globally scoped callback for the map loaded
	 */
	mapLoaded() {
		if (this.resolve) {
			this.resolve();
		}
	}
}
